import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ToastType } from '../toast-types';

@Component({
  selector: 'lib-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ToastComponent {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  self: any;
  title: string;
  message: string;
  type: ToastType;

  public ToastType = ToastType;

  hide() {
    this.self.hide();
  }
}
